export default {
  setTrainerReviewDialog(state, payload) {
    state.trainerReviewDialog = payload;
  },
};
